<div class="container-fluid">

  <button (click)="addNewPrivilege()" type="button" class="mx-0 btn btn-outline-primary btn-lg btn-block mt-4 mb-2">
    {{'ADD' |translate}}
    <i class="fa fa-plus fa-1x icons-style" aria-hidden="true" placement="left"
      ngbTooltip="{{ 'ADD' | translate }}"></i>
  </button>


  <p-dataTable tableStyleClass="table table-bordered table-striped" [value]="therapeuticCard" selectionMode="single"
    [rows]="10" [lazy]="true" (onPage)="paginate($event)" [paginator]="true" [pageLinks]="3"
    [rowsPerPageOptions]="[5,10,20,50,100]">
    <p-column field="code" header="{{ 'SERIAL' | translate }}"></p-column>
    <p-column field="patientCode" header="{{ 'PATCODE' | translate }}"></p-column>
    <p-column field="cardNo" header="{{ 'CARDNUMBER' | translate }}">
      <ng-template pTemplate="options" let-row="rowData">
        <input *ngIf="row.updatestatus == 2 || row.dataStatus==2 || row.dataStatus ==1" type="text" class="form-control"
          [(ngModel)]="row.cardNo" />
        <b *ngIf="row.updatestatus != 2 &&  row.dataStatus!= 1">{{row.cardNo}}</b>
      </ng-template>
    </p-column>
    <p-column field="contractId" header="{{ 'contractID' | translate }}">
      <ng-template pTemplate="options" let-row="rowData">
        <sanabel-selectize *ngIf="row.dataStatus== 1" (clicked)="contractClicked($event ,row)" appcode="1040"
          [simpleView]="true" [(ngModel)]="row.contractId">
        </sanabel-selectize>
        <span *ngIf="row.updatestatus != 2 &&  row.dataStatus!= 1">
          {{translate.currentLang == 'ar' ? row.contractId : row.contractId}}
        </span>
      </ng-template>
    </p-column>
    <p-column field="{{translate.currentLang == 'ar' ? 'contractNameAr':'contractNameEn'}}"
      header="{{ 'CONTRACNAME' | translate }}"></p-column>
    <p-column field="{{translate.currentLang == 'ar' ? 'mainCompanyNameAr':'mainCompanyNameEn'}}"
      header="{{ 'COPANYNAME' | translate }}"></p-column>
    <p-column field="policyNumber" header="{{ 'PolicyNumber' | translate }}"></p-column>
    <p-column field="startDate" header="{{ 'StartDate' | translate }}">

    </p-column>
    <p-column header="{{ 'ENDDATE' | translate }}">
      <ng-template pTemplate="options" let-row="rowData">
        <div *ngIf="row.updatestatus != 2 && row.dataStatus!= 1">
          <i>
            {{row['endDate'] | date:'dd/MM/yyyy'}}
          </i>
        </div>
        <div *ngIf="row.updatestatus == 2  || row.dataStatus== 1" class="col-sm-12" style="padding-top: 10px;">
          <div class="form-group">
            <div class="input-group input-group-sm">
              <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}" [(ngModel)]="row.endDate"
                name="endDate" ngbDatepicker #endDate="ngbDatepicker">
              <div class="input-group-addon" (click)="endDate.toggle()">
                <i class="fa fa-calendar"></i>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </p-column>
    <p-column header="{{ 'STATUS' | translate }}" [style]="{'width': '8%'}" [sortable]="true">
      <ng-template pTemplate="options" let-row="rowData">
        <sanabel-selectize *ngIf="row.updatestatus == 2 ||  row.dataStatus== 1" appcode="389" [simpleView]="true"
          [(ngModel)]="row.rowStatus">
        </sanabel-selectize>
        <span *ngIf="row.updatestatus != 2 &&  row.dataStatus!= 1">
          {{translate.currentLang == 'ar' ? row.rowStatusAr : row.rowStatusEn}}
        </span>
      </ng-template>
    </p-column>
    <p-column header="{{ 'ACTIONS' | translate }}" [style]="{'width': '10%'}">
      <ng-template pTemplate="options" let-row="rowData">
        <span *ngIf="row.updatestatus != 2" class="">
          <icon-action (clicked)="onRowIconClick($event,row)" [appCodes]="[403,402]">
          </icon-action>
        </span>
        <div>
          <button *ngIf="row.updatestatus == 2" class="btn btn-info btn-sm" (click)="undoEdit(row);">
            <i class="fa fa-undo fa-1x"></i>
          </button>
          <button *ngIf="row.updatestatus == 2" class="btn btn-success btn-sm" (click)="UpdateEdit(row);">
            <i class="fa fa-save fa-1x"></i>
          </button>
        </div>
      </ng-template>
    </p-column>
  </p-dataTable>


  <div class="row">
    <div class="col text-center">
      <btns-ctrl #btnCtrl1 [appCodes]="[1]" (clicked)="save()"></btns-ctrl>
    </div>
  </div>


  <!-- added by basma  -->
  <div class="row">
    <div class="title-tab-step text-center border-radius" style="border-radius: 15px 50px 30px 5px;">
      {{'NPHIES COVERAGE CLASSIFIACTION OF PATIENT' |translate}}
    </div>
  </div>
  <div class="row">
    <div class="col">
      <button (click)="addNewCoverageClass()" type="button"
        class="mx-0 btn btn-outline-primary btn-lg btn-block mt-4 mb-2">
        {{'ADD' |translate}}
        <i class="fa fa-plus fa-1x icons-style" aria-hidden="true" placement="left"
          ngbTooltip="{{ 'ADD' | translate }}"></i>
      </button>
    </div>
  </div>
  <div class="row">
    <p-dataTable tableStyleClass="table table-bordered table-striped" [value]="nphiesCoverageClass"
      selectionMode="single" [rows]="10" [lazy]="true" (onPage)="paginate($event)" [paginator]="true" [pageLinks]="3"
      [rowsPerPageOptions]="[5,10,20,50,100]">
      <p-column field="serial" header="{{ 'SERIAL' | translate }}"></p-column>
      <p-column field="patCode" header="{{ 'PATCODE' | translate }}"></p-column>
      <p-column field="identityValue" header="{{ 'IdentityValue' | translate }}"></p-column>

      <p-column field="memberID" header="{{ 'CARDNUMBER' | translate }}">
        <ng-template pTemplate="options" let-row="rowData">
          <input  *ngIf="row.dataStatus ==  1   || row.dataStatus ==  2"  type="text" class="form-control"
            [(ngModel)]="row.memberID" />
          <span  *ngIf="!row.dataStatus || row.dataStatus ==  3  " [ngClass]="{'deleted-row':row.dataStatus == 3}">{{row.memberID}}</span>
        </ng-template> </p-column>
 

      <p-column field="policyNo" header="{{ 'PolicyNumber' | translate }}">
        <ng-template pTemplate="options" let-row="rowData">
          <input  *ngIf="row.dataStatus ==  1   || row.dataStatus ==  2"  type="text" class="form-control"
            [(ngModel)]="row.policyNo" />
          <span   *ngIf="!row.dataStatus || row.dataStatus ==  3 "  [ngClass]="{'deleted-row':row.dataStatus == 3}">{{row.policyNo}}</span>
        </ng-template> 
      </p-column>
      <p-column field="policyName" header="{{ 'PolicyName' | translate }}">
        <ng-template pTemplate="options" let-row="rowData">
          <input   *ngIf="row.dataStatus ==  1   || row.dataStatus ==  2" type="text" class="form-control"
            [(ngModel)]="row.policyName" />
          <span   *ngIf="!row.dataStatus || row.dataStatus ==  3 "  [ngClass]="{'deleted-row':row.dataStatus == 3}">{{row.policyName}}</span>
        </ng-template> 
      </p-column>

      <p-column field="coverageClassType" header="{{ 'CoverageClassType' | translate }}"> 
        <ng-template pTemplate="options" let-row="rowData">
          <!-- <input  *ngIf="row.dataStatus ==  1   || row.dataStatus ==  2" type="text" class="form-control"
            [(ngModel)]="row.coverageClassType" /> -->

            <div *ngIf="row.dataStatus ==  1   || row.dataStatus ==  2"  class="custom-dropdown">
              <sanabel-selectize appcode="89" [SearchKeys]="{NphiesCodes:1}"  
                (clicked)="onCoverageClassTypeClick($event,row)" [(ngModel)]="row.coverageClassTypeCode"
               [simpleView]="true"></sanabel-selectize>
            </div>


          <span  *ngIf="!row.dataStatus || row.dataStatus ==  3 "  [ngClass]="{'deleted-row':row.dataStatus == 3}">{{row.coverageClassType}}</span>
        </ng-template>
      </p-column>
      <p-column field="coverageClassvalue" header="{{ 'CoverageClassvalue' | translate }}">
        <ng-template pTemplate="options" let-row="rowData">
          <input  *ngIf="row.dataStatus ==  1   || row.dataStatus ==  2" type="text" class="form-control"
            [(ngModel)]="row.coverageClassvalue" />
          <span  *ngIf="!row.dataStatus || row.dataStatus ==  3 "  [ngClass]="{'deleted-row':row.dataStatus == 3}">{{row.coverageClassvalue}}</span>
        </ng-template>
       </p-column>
      <p-column field="coverageClassName" header="{{ 'CoverageClassName' | translate }}"> 

        <ng-template pTemplate="options" let-row="rowData">
          <input  *ngIf="row.dataStatus ==  1 || row.dataStatus ==  2" type="text" class="form-control"
            [(ngModel)]="row.coverageClassName" />
          <span   *ngIf="!row.dataStatus || row.dataStatus ==  3 "  [ngClass]="{'deleted-row':row.dataStatus == 3}">{{row.coverageClassName}}</span>
        </ng-template>
      </p-column>

      <p-column header="{{ 'ACTIONS' | translate }}" [style]="{'width': '10%'}">
        <ng-template pTemplate="options" let-row="rowData">
          <span *ngIf="!row.dataStatus" class="">
            <icon-action (clicked)="onCoverageClassRowIconClick($event,row)" [appCodes]="[403,402]">
            </icon-action>
          </span>
          <div>
            <button *ngIf="row.dataStatus ==  1 || row.dataStatus ==  2"  class="btn btn-info btn-sm" (click)="undoCoverageClassEdit(row);">
              <i class="fa fa-undo fa-1x"></i>
            </button>
            <button *ngIf="row.dataStatus ==  1 || row.dataStatus ==  2"  class="btn btn-success btn-sm" (click)="updateCoverageClass(row);">
              <i class="fa fa-save fa-1x"></i>
            </button>
          </div>
        </ng-template>
      </p-column>

    </p-dataTable>
   
  <div class="row">
    <div class="col text-center">
      <btns-ctrl #btnCtrl1 [appCodes]="[1]" [disabled]=" disableFlag == 1" (clicked)="saveCoverageClass()"></btns-ctrl>
    </div>
  </div>